<template>
  <div class="myfinbiz-page">
    <MyfinbizIntro v-if="!showSurvey" @start-survey="startSurvey" />
    <MyfinbizChatSurvey v-else />
  </div>
</template>

<script>
import MyfinbizIntro from '@/components/myfinbiz/MyfinbizIntro.vue'
import MyfinbizChatSurvey from '@/components/myfinbiz/MyfinbizChatSurvey.vue'

export default {
  name: 'Myfinbiz',
  components: {
    MyfinbizIntro,
    MyfinbizChatSurvey
  },
  data() {
    return {
      showSurvey: false
    }
  },
  methods: {
    startSurvey() {
      this.showSurvey = true
    }
  }
}
</script>

<style scoped>
.myfinbiz-page {
  max-width: 800px;
  margin: 0 auto;
  padding: 0px;
}
</style>
